module.exports = __webpack_public_path__ + "img/swap.b23ffe57.svg";